import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * Per-screen error boundary: an unhandled render error shows a contained error
 * state (StatePanel-style) rather than blanking the whole app. It logs NOTHING
 * sensitive (no financial value / token) — only that a render error occurred.
 */
export class ErrorBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // Intentionally do not log the error object (may contain rendered financial values).
    // A production build reports only that a UI render error occurred.
  }

  render(): ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
